const storageLanguage = () => {
  if (localStorage.getItem("i18nextLng")) {
    return localStorage.getItem("i18nextLng");
  }
  return "kk";
};

export default storageLanguage;
